<div id="top-el"></div>
<div class="wrapper wrapper__selfevaluation continue-later" [hidden]="hide"
     [ngStyle]="deviceInnerHeight > 0 ?
        {
            'min-height': deviceInnerHeight + 'px'
        } : ''"
>
    <div class="row container">
        <div class="col-xs-12 col-md-3 offset-md-1">
            <a class="selfevaluation__icon" [routerLink]="['/login']">
                <i class="selfevaluation__icon--fa end"></i>
            </a>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <h1 class="wrapper__title font-se-title">{{'Self Evaluation Introduction' | translate}}</h1>
        </div>
    </div>
    <div class="row wrapper__introduction">
        <div class="col-xs-12 col-sm-8">
            <span class="wrapper__introduction__content">{{"This survey is paused. Please come later and complete it by clicking on the link in the email you recieved for this survey." | translate}}</span>
            <br/>
            <span class="wrapper__introduction__content">{{'You can close this window now' | translate}}</span>
        </div>
    </div>
    <div class="row wrapper__btns">
        <div class="col-sm-12 slide-navigator">
            <button (click)="backToSEPage()" type="submit" class="btn btn-primary badge-pill pd-v--sm btn-xs-full">
                <i class="fas fa-clock"></i>
                {{ 'Continue Questionnaire' | translate }}
            </button>
        </div>
    </div>
</div>
